// eslint-disable-next-line object-curly-newline
import axios from 'axios'
import { getCurrentInstance, reactive, toRefs, watch } from 'vue'
import { useTranslate } from './Translate'
import dayjs from 'dayjs';
const { __t } = useTranslate();
export const isNumeric = (value) => {
    return /^\d+$/.test(value); // أرقام فقط
}

export const isFloat = (value) => {
    return /^\d+\.\d+$/.test(value); // أرقام مع نقطة عشرية
}
export const checkExpired = (date) => {
    const today = dayjs().startOf('day'); // تاريخ اليوم بدون وقت
    const targetDate = dayjs(date).startOf('day'); // التاريخ المُقارَن

    return targetDate.isBefore(today);
  }
export const convertToHumanReadable = (minutes) => {
    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;
    let result = "";
    if (hours > 0) {
        result += hours + "h ";
    }
    if (mins > 0) {
        result += mins + "m";
    }
    return result;
};
export const isValidHttpUrl = (string) => {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
};
export const getPresence = async (channel) => {

    let users = []
    await axios.get(route('api.getCountPresence', channel)).then(response => {
        users = response.data.users
        return users
    });

}
export const getIconByExtension = (extension) => {
    if (extension == null) return 'mdi-file';
    switch (extension.toLowerCase()) {
        case 'pdf':
            return 'mdi-file-pdf-box';
        case 'doc':
        case 'docx':
            return 'mdi-file-word';
        case 'xls':
        case 'xlsx':
            return 'mdi-file-excel';
        case 'ppt':
        case 'pptx':
            return 'mdi-file-powerpoint';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return 'mdi-file-image-outline';
        case 'mp4':
        case 'avi':
        case 'mkv':
            return 'mdi-youtube';
        case 'mp3':
        case 'wav':
            return 'mdi-music-circle-outline';
        case 'zip':
        case 'rar':
            return 'mdi-folder-zip';
        default:
            return 'mdi-file';
    }
};
/**
 * Convert a duration in seconds to a human-readable format.
 *
 * @param {number} seconds - The duration in seconds.
 * @returns {string} The human-readable duration.
 */
export const formatDuration = (seconds) => {
    if (seconds === 0) return __t('not_defined');

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    let formattedDuration = "";

    if (hours > 0) {
        formattedDuration += hours + " " + __t('hours') + (hours > 1 ? " " : "");
    }

    if (minutes > 0) {
        if (formattedDuration !== "") {
            formattedDuration += ' ' + __t('and');
        }
        formattedDuration += minutes + " " + __t('minutes') + (minutes > 1 ? " " : "");
    }

    if (secs > 0) {
        if (formattedDuration !== "") {
            formattedDuration += ' ' + __t('and');
        }
        formattedDuration += secs + " " + __t('seconds');
    }

    return formattedDuration;
}
export const formatDurationMinutes = (minutes) => {
    if (minutes === 0) return __t('not_defined');

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = Math.floor(minutes % 60);

    let formattedDuration = "";

    if (hours > 0) {
        formattedDuration += hours + " " + __t('hours') + (hours > 1 ? " " : "");
    }

    if (remainingMinutes > 0) {
        if (formattedDuration !== "") {
            formattedDuration += ' ' + __t('and');
        }
        formattedDuration += remainingMinutes + (remainingMinutes <= 11 ? " " + __t('minutes') : " " + __t('minute')) + (remainingMinutes > 1 ? " " : "");
    }

    return formattedDuration;
}

export const formatDurationForNote = (seconds) => {
    if (seconds === 0) return __t('not_defined');

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    let formattedDuration = "";

    if (hours > 0) {
        formattedDuration += __t('hours') + " " + hours + (hours > 1 ? " " : "");
    }

    if (minutes > 0) {
        if (formattedDuration !== "") {
            formattedDuration += ' ' + __t('and');
        }
        formattedDuration += __t('minutes') + " " + minutes + (minutes > 1 ? " " : "");
    }

    if (secs > 0) {
        if (formattedDuration !== "") {
            formattedDuration += ' ' + __t('and');
        }
        formattedDuration += __t('seconds') + " " + secs;
    }

    return formattedDuration;
}
export const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export const nFormatter = (num, digits) => {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup.slice().reverse().find(function (item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export const cleanObject = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}
export const addLanguageKeys = (obj, languages) => {
    languages.forEach(lang => {
        if (!obj[lang]) {
            obj[lang] = ''; // تعيين قيمة افتراضية إذا لم تكن موجودة
        }

    });

    // remove any key that is not in languages and remove properties that are not in languages
    for (var key in obj) {
        if (!languages.includes(key)) {
            delete obj[key];
        }
    }
    return obj;


}
export const isObject = obj => typeof obj === 'object' && obj !== null
export const includeAny = (str, substrings) => {

    if (typeof substrings == 'array') {
        for (var i = 0; i != substrings.length; i++) {
            var substring = substrings[i];
            if (str.includes(substring)) {
                return true;
            }
        }
    } else if (isObject(substrings)) {

        for (const substring of substrings) {
            if (str.includes(substring)) {
                return true;
            }
        }
    }

    else {
        return str.includes(substrings)
    }

    return false;
}

export const isToday = date => {
    const today = new Date()

    return (
        /* eslint-disable operator-linebreak */
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
        /* eslint-enable */
    )
}

export const dateInPast = (firstDate, secondDate) => {
    if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
        return true
    }

    return false
}

export const getVuetify = () => {
    const ins = getCurrentInstance()?.proxy

    return ins && ins.$vuetify ? ins.$vuetify : null
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
    const vm = getCurrentInstance().proxy

    const state = reactive({
        route: vm.$route,
    })

    watch(
        () => vm.$route,
        r => {
            state.route = r
        },
    )

    return { ...toRefs(state), router: vm.$inertia }
}

export const isEmpty = value => {
    if (value === null || value === undefined || value === '') {
        return true
    }

    if (Array.isArray(value) && value.length === 0) {
        return true
    }

    return false
}

// ——— Get Initial Text from name ——————— //

export const getInitialName = fullName =>
    // eslint-disable-next-line implicit-arrow-linebreak
    fullName
        .split(' ')
        .map(n => n[0])
        .join('')

// ——— Add Alpha To color ——————— //

export const addAlpha = (color, opacity) => {
    const opacityLocal = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)

    return color + opacityLocal.toString(16).toUpperCase()
}

// ——— Perfect Scrollbar Scroll to bottom ——————— //

export const psScrollToBottom = psRef => () => {
    const scrollEl = psRef.value.$el || psRef.value
    scrollEl.scrollTop = scrollEl.scrollHeight
}

// ——— Perfect Scrollbar Scroll to bottom ——————— //

export const psScrollToTop = psRef => () => {
    const scrollEl = psRef.value.$el || psRef.value
    scrollEl.scrollTop = 0
}

// ————————————————————————————————————
//* ——— Color Manipulations
// ————————————————————————————————————

// Thanks: https://stackoverflow.com/a/5624139/10796681
export const rgbToHex = (r, g, b) => {
    const componentToHex = c => {
        const hex = c.toString(16)

        return hex.length === 1 ? `0${hex}` : hex
    }

    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`
}

// Thanks: https://stackoverflow.com/a/5624139/10796681
export const hexToRgb = hex => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    // eslint-disable-next-line no-param-reassign
    hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b)

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

    /* eslint-disable indent */
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null
    /* eslint-enable */
}

// Return the color for each status
export const statusColor = (status) => {
    switch (status) {
        case 'follow_up':
            return 'follow-up-base'
        case 'not_answered':
            return 'no-answer-base'
        case 'interested':
            return 'interested-base'
        case 'not_interested':
            return 'not-interested-base'
        case 'reserved':
            return 'interested'
        case 'new_call':
            return 'shadow'
    }
}

export const statusTextColor = (status) => {
    switch (status) {
        case 'follow_up':
            return 'follow-up'
        case 'not_answered':
            return 'no-answer'
        case 'interested':
            return 'interested'
        case 'not_interested':
            return 'not-interested'
        case 'reserved':
            return 'interested-base'
        case 'new_call':
            return 'white'
    }
}
